module.exports = __webpack_public_path__ + "static/media/pre.db9a3d7a.svg";